/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Score_Feature_DepthInputs */

const en_directory_score_feature_depth = /** @type {(inputs: Directory_Score_Feature_DepthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature depth`)
};

const zh_directory_score_feature_depth = /** @type {(inputs: Directory_Score_Feature_DepthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能深度`)
};

/**
* | output |
* | --- |
* | "Feature depth" |
*
* @param {Directory_Score_Feature_DepthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_score_feature_depth = /** @type {((inputs?: Directory_Score_Feature_DepthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Score_Feature_DepthInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_score_feature_depth(inputs)
	return zh_directory_score_feature_depth(inputs)
});
export { directory_score_feature_depth as "directory.score.feature_depth" }